import { render, staticRenderFns } from "./ViewCreditHistory.vue?vue&type=template&id=b647c4cc&"
import script from "./ViewCreditHistory.vue?vue&type=script&lang=js&"
export * from "./ViewCreditHistory.vue?vue&type=script&lang=js&"
import style0 from "./ViewCreditHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports